module.exports = __webpack_public_path__ + "static/media/processing.a6e3d85f.gif";